module.exports = __webpack_public_path__ + "static/media/checkmark_check_tick-green.d3b22489.svg";